import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { LoyaltyLeaderboardSection } from "Components/Loyalty/Shared/Leaderboard/LoyaltyLeaderboardSection";
import { LoyaltyPointType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

export const LeaderboardSection = () => {
  const { t } = useResource();

  return (
    <LoyaltyLeaderboardSection
      pointType={LoyaltyPointType.Stardust}
      title={t(Resources.Pages.Content.Stardust.Leaderboard.Title)}
      scoreIcon={<AutoAwesomeIcon />}
    />
  );
};
